import useSWR from "swr";

type SurveyQuestions = {
  id: string;
  restaurant: string;
  question: string;
  answer_count: number;
  is_selected: boolean;
}[]

export const useFetchSoCouponSurveyQuestionsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `socoupon/restaurants/${restaurantId}/survey/questions/` : null;
  const { data: surveyQuestions, error, isLoading } = useSWR<SurveyQuestions>(fetcherKey)
  return { surveyQuestions, isLoading, error };
};
